var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1965",
    "data-name": "Rectangle 1965",
    width: 52,
    height: 52,
    transform: "translate(396 395)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5",
    "data-name": "Mask Group 5",
    transform: "translate(-396 -395)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c-sharp-c-seeklogo.com",
    transform: "translate(398.867 395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19638",
    "data-name": "Path 19638",
    d: "M46.264,15.288a4.592,4.592,0,0,0-.566-2.31,4.417,4.417,0,0,0-1.674-1.631Q34.786,6.02,25.543.7a4.537,4.537,0,0,0-4.917.049C18.174,2.194,5.9,9.227,2.242,11.345A4.272,4.272,0,0,0,0,15.286Q0,26,0,36.713a4.608,4.608,0,0,0,.541,2.266,4.4,4.4,0,0,0,1.7,1.675c3.658,2.119,15.934,9.15,18.385,10.6a4.538,4.538,0,0,0,4.918.049q9.236-5.333,18.484-10.647a4.4,4.4,0,0,0,1.7-1.675,4.614,4.614,0,0,0,.541-2.266s0-14.281,0-21.423",
    fill: "#a179dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19639",
    "data-name": "Path 19639",
    d: "M23.2,25.93.541,38.979a4.4,4.4,0,0,0,1.7,1.675c3.658,2.119,15.934,9.15,18.385,10.6a4.538,4.538,0,0,0,4.918.049q9.236-5.333,18.484-10.647a4.4,4.4,0,0,0,1.7-1.675L23.2,25.93",
    fill: "#280068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19640",
    "data-name": "Path 19640",
    d: "M46.264,15.288a4.592,4.592,0,0,0-.566-2.31L23.2,25.93,45.726,38.978a4.618,4.618,0,0,0,.541-2.266s0-14.281,0-21.423",
    fill: "#390091"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19641",
    "data-name": "Path 19641",
    d: "M36.548,21.052v2.439h2.439V21.052h1.22v2.439h2.439v1.22H40.206V27.15h2.439v1.22H40.206v2.439h-1.22V28.369H36.548v2.439h-1.22V28.369H32.889V27.15h2.439V24.711H32.889v-1.22h2.439V21.052Zm2.439,3.659H36.548V27.15h2.439Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19642",
    "data-name": "Path 19642",
    d: "M23.254,8.8a17.191,17.191,0,0,1,14.891,8.591l-.029-.049-7.485,4.31a8.559,8.559,0,0,0-7.28-4.217h-.1A8.563,8.563,0,1,0,30.716,30.2l-.036.063,7.474,4.33A17.192,17.192,0,0,1,23.445,43.2h-.192a17.2,17.2,0,1,1,0-34.395Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsharp);
export default __webpack_public_path__ + "static/media/csharp.1143009d7744d508933554a251a2b959.svg";
export { ForwardRef as ReactComponent };